<template>
  <ion-page>
    <ion-content class="ion-padding-top bg-grad-content product-list">
      <ion-list
        v-if="products.length > 0"
        style="margin-bottom: 50px"
        class="ion-padding-top"
      >
        <ion-item
          v-for="(item, index) in products"
          :key="index"
          lines="none"
          :class="index == 0 ? 'ion-padding-top' : ''"
        >
          <ion-card>
            <img
              v-lazy="item.mainimage.data.imagen"
              width="800"
              @click="goProductImages(item.imageprod)"
            />
            <ion-card-header>
              <ion-card-subtitle v-if="mdmoto" class="">{{
                `${mdmoto.descripcion} - ${mdmoto.marcamoto.data.descripcion}`
              }}</ion-card-subtitle>
              <ion-card-title class="">{{ item.nombre }}</ion-card-title>
              <ion-text color="secondary">
                <h3>{{ $filters.currencyFormat(item.precio) }}</h3>
              </ion-text>
            </ion-card-header>
            <ion-card-content class="ellipse" v-if="item.descripcion">
              {{ item.descripcion }}
            </ion-card-content>
            <ion-footer>
              <ion-row>
                <ion-col
                  class="ion-text-center"
                  @click="addProductToCart(item)"
                >
                  <i class="mdi mdi-cart-plus mdi-36px"></i>
                </ion-col>
                <ion-col class="ion-text-center" @click="likeProduct(item)">
                  <i class="mdi mdi-briefcase-check-outline mdi-36px"></i>
                </ion-col>
                <ion-col
                  class="ion-text-center"
                  @click="
                    goWhatsApp(
                      `Hola, quiero información sobre: ${mdmoto.descripcion} - ${mdmoto.marcamoto.data.descripcion}, ${item.nombre}`
                    )
                  "
                  ><i class="mdi mdi-whatsapp mdi-36px color-green"></i>
                </ion-col>
                <ion-col class="ion-text-center" @click="goProduct(item)">
                  <i class="mdi mdi-location-enter mdi-36px"></i>
                </ion-col>
              </ion-row>
            </ion-footer>
          </ion-card>
        </ion-item>
      </ion-list>
      <ion-infinite-scroll
        v-if="isDisabled"
        @ionInfinite="goNextPage($event)"
        threshold="100px"
        id="infinite-scroll"
      >
        <ion-infinite-scroll-content
          loading-spinner="bubbles"
          loading-text="Cargando mas datos..."
        >
        </ion-infinite-scroll-content>
      </ion-infinite-scroll>
    </ion-content>
  </ion-page>
</template>

<script>
export default {
  components: {},
  data(vm) {
    return {
      isDisabled: false,
      nextPage: '',
      routeParams: {
        motobrand: '',
        motomodel: ''
      },
      products: [],
      mdmoto: null
    }
  },
  ionViewDidEnter() {
    this.$store.dispatch('app/keepPageState', false)
  },
  ionViewDidLeave() {},
  ionViewWillEnter() {
    if (!this.$store.getters['app/keepPageState']) {
      this.isDisabled = false
      this.products = []
      this.routeParams = this.$route.params
      this.getIndexData()
    }
  },
  ionViewWillLeave() {},
  created() {},
  beforeUnmount() {},
  mounted() {},
  watch: {
    $route(to, from) {
      if (
        from.name === 'product-list' &&
        to.name === 'product-list' &&
        !this.$store.getters['app/keepPageState']
      ) {
        this.isDisabled = false
        this.products = []
        this.routeParams = to.params
        this.getIndexData()
      }
    }
  },
  computed: {},
  methods: {
    goWhatsApp(text) {
      window.open(`https://wa.me/573213813097?text=${text}`, '_blank')
    },
    addProductToCart(product) {
      product.slug = `/${this.mdmoto.marcamoto.data.descripcion_hide}/${this.mdmoto.descripcion_hide}/${this.mdmoto.id}/${product.id}`
      product.main_image = product.mainimage.data.imagen
      product.ref = `${this.mdmoto.marcamoto.data.descripcion} - ${this.mdmoto.descripcion}`
      this.$store.dispatch('cart/addProductToCart', product)
      this.$emitter.emit('toast', {
        message: 'Producto agregado al carro',
        color: 'primary'
      })
    },
    likeProduct(item) {
      let product = {
        id: item.id,
        name: item.nombre,
        image: item.mainimage.data.imagen,
        price: item.precio,
        ref: `${this.mdmoto.marcamoto.data.descripcion} - ${this.mdmoto.descripcion}`,
        slug: `/${this.mdmoto.marcamoto.data.descripcion_hide}/${this.mdmoto.descripcion_hide}/${this.mdmoto.id}/${item.id}`,
        quantity: 1
      }
      this.$store.dispatch('app/messageData', {
        title: 'Quiero Comprar',
        product: product,
        mdmoto: this.mdmoto
      })
      this.$store.dispatch('app/keepPageState', true)
      this.$router.push({ name: 'messageme' })
    },
    goProduct(item) {
      this.$router.push({
        name: 'product-detail',
        params: {
          motobrand: this.routeParams.motobrand,
          motomodel: this.routeParams.motomodel,
          motomodel_id: this.routeParams.motomodel_id,
          product_id: item.id
        }
      })
    },
    async zoomImage(image) {
      this.$store.dispatch('app/keepPageState', true)
      this.$store.dispatch('app/imageToView', image)
      this.$router.push({ name: 'view-image' })
    },
    async goProductImages(images) {
      console.log(images)
      this.$store.dispatch('app/keepPageState', true)
      this.$store.dispatch('app/productImageToView', images)
      this.$router.push({ name: 'product-image-list' })
    },
    getIndexData() {
      this.$emitter.emit('full-loader', { open: true })
      let data = this.routeParams
      this.$http
        .get('app-mobile/product-list', { params: data })
        .then((res) => {
          this.products = res.data.products.data
          if (res.data.products.meta.pagination.total_pages > 1) {
            this.isDisabled = true
            this.nextPage = res.data.products.meta.pagination.links.next
          }
          this.mdmoto = res.data.mdmoto.data
          this.$emitter.emit('full-loader', { open: false })
        })
        .catch((err) => {
          this.$emitter.emit('full-loader', { open: false })
        })
    },
    goNextPage(infiniteScroll) {
      let data = this.routeParams
      this.$http
        .get(this.nextPage, { params: data })
        .then((res) => {
          this.products = this.products.concat(res.data.products.data)
          if (res.data.products.meta.pagination.links.next) {
            this.nextPage = res.data.products.meta.pagination.links.next
            this.isDisabled = true
          } else this.isDisabled = false
          infiniteScroll.target.complete()
        })
        .catch((err) => {})
    }
  }
}
</script>

<style>
.truncate {
  width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.product-list .list-ios {
  background: transparent;
}
.product-list .list-md {
  background: transparent;
}
.product-list .item-native {
  background: transparent;
}

.product-list ion-item {
  --background: transparent;
  --border-color: transparent;
}
.ellipse {
  width: 300px;
  height: 2.8em;
  line-height: 1.4em;
  display: flex;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
